<template>
  <div>
    <vx-card class="relative">
      <div>
        <vs-row vs-w="12" class="mb-5">
          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <vs-button @click="goBack" color="primary" type="border"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>{{ campaignDescription.campaign_name }}</h3>
            
          </vs-col>

          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <!-- <vs-button type="filled"
              @click="campaignDataOptions">Campaign Data Options</vs-button> -->
          </vs-col>

          <vs-col vs-lg="1" vs-sm="4" vs-xs="12"> 
            
          </vs-col>
        </vs-row>
      </div>
    </vx-card>


    <vx-card class="vxtable">

   <vs-row vs-w="12" class="mb-10">
          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            
          </vs-col>
        
        
        
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="4"
            vs-xs="12"
          >
            <h3> Account : {{contactDescription._ec41e532_632d_4323_8071_f60b4543a68a}}</h3>
             <vs-icon
                      @click.stop="viewAccountDetails(contactDescription.accepted)"
                      size="small"
                      icon="info"
                      style="cursor: pointer; margin-left: 15px"
                    ></vs-icon>
          </vs-col>

    

          <vs-col vs-lg="4" vs-sm="4" vs-xs="12"> 

            
          </vs-col>
        </vs-row>





     
     

      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-lg="8" vs-sm="8" vs-xs="12">
      

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Title:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="title"
                v-model="contactDescription.title"
                data-vv-as="Title"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Forename:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="forename"
                data-vv-as="Forename"
                v-validate="'required'"
                v-model="contactDescription.forename"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('forename')"
              >{{ errors.first('forename') }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Surname:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="surname"
                data-vv-as="Surname"
                v-validate="'required'"
                v-model="contactDescription.surname"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('surname')"
              >{{ errors.first('surname') }}</span
            >
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Job Title:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                v-validate="'required'"
                name="job_title"
                data-vv-as="Job Title"
                class="w-full"
                v-model="contactDescription.job_title"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('job_title')"
              >{{ errors.first('job_title') }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Seniority:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <div
                :class="{
                  correction_field_input_class:
                    correction_fields_array.includes('seniority')
                }"
              >
                <v-select
                  name="seniority"
                  data-vv-as="Seniority"
                  label="seniority"
                  :options="contacts.seniorities"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="contactDescription.seniority"
                />
              </div>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Role:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <div
                :class="{
                  correction_field_input_class:
                    correction_fields_array.includes('role')
                }"
              >
                <v-select
                  data-vv-as="Role"
                  name="role"
                  label="role"
                  :options="contacts.roles"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="contactDescription.role"
                />
              </div>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Sub Role:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <v-select
                data-vv-as="Sub Role"
                name="sub_role"
                label="sub_role"
                :options="contacts.sub_roles"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="contactDescription.sub_role"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <h5 class="mb-5">Email</h5>

              <div class="vx-row p-2">
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input
                    class="w-full"
                    name="email"
                    v-model="contactDescription.email"
                    data-vv-as="Email"
                  />
                </div>

                <vs-button
                  color="primary"
                  @click="validateEmailZeroBounce(contactDescription.email)"
                  type="filled"
                  >Check & Add</vs-button
                >

                <span class="ml-5">{{ email_validate_status }} </span>
              </div>
            </div>
            <div class="vx-col sm:w-1/5 w-full"></div>
          </div>

          <template v-for="(email, index) in contactDescription.emails">
            <div class="m-5">
              {{ email.email }}

              <vs-icon
                class="removeButton"
                @click="removeSelectedEmail(email)"
                color="success"
                icon="clear"
              >
              </vs-icon>
            </div>
          </template>

          <vs-divider class="m-5" />


            <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <h5 class="mb-5">Social Media</h5>

              <div class="vx-row p-2">
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input
                    class="w-full"
                    name="social_media"
                    v-model="contactDescription.social_media"
                    data-vv-as="Social Media"
                  />
                </div>
                 <div class="vx-col sm:w-1/2 w-full">
              <vs-textarea
              v-model="contactDescription.summary"
            />

           

            
            
            
            </div>

              

              </div>
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-button
                  color="primary"
                  @click="addSocialMedia(contactDescription.social_media , contactDescription.summary)"
                  type="filled"
                  >Check & Add</vs-button
                >
            </div>
          </div>

          <template v-for="(social_media, index) in contactDescription.social_medias">
            <div class="m-5">
              {{ social_media.social_media }} {{ ' - ' + social_media.summary }}

              <vs-icon
                class="removeButton"
                @click="removeSelectedSocialMedia(social_media)"
                color="success"
                icon="clear"
              >
              </vs-icon>
            </div>
          </template>

          <!-- <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">Social Media Pages</h5>
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-button color="primary" @click="addSocialMedia" type="filled"
                >Add</vs-button
              >
            </div>
          </div>

          <template
            v-for="(social_media, index) in contactDescription.social_medias"
          >
            <div class="vx-row">
              <div class="vx-col sm:w-1/5 w-full">
                <vs-input
                  class="w-full"
                  name="social_media"
                  v-model="social_media.social_media"
                  data-vv-as="Social Media"
                />
                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('social_media')"
                  >{{ errors.first('social_media') }}</span
                >
              </div>
              <div class="vx-col sm:w-1/5 w-full">
                <vs-textarea v-model="social_media.summary" />
              </div>

              <div class="vx-col sm:w-1/5 w-full">
              

                <vs-icon
                  class="removeButton"
                  @click="removeSelectedSocialMedia(social_media)"
                  color="success"
                  icon="clear"
                >
                </vs-icon>
              </div>
            </div>
          </template> -->

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">DDI</h5>
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-button color="primary" @click="addDDI" type="filled"
                >Add</vs-button
              >
            </div>
          </div>

          <template v-for="(ddi, index) in contactDescription.ddis">
            <div class="vx-row p-2">
              <div class="vx-col sm:w-1/5 w-full">
                <div
                  :class="{
                    correction_field_input_class:
                      correction_fields_array.includes('ddi_phone_code')
                  }"
                >
                  <v-select
                    name="ddi_phone_code"
                    class="ddi_phone_code"
                    label="name_with_code"
                    :options="all_phone_codes"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ddi.ddi_phone_code"
                  />
                </div>

                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('ddi')"
                  >{{ errors.first('ddi') }}</span
                >
              </div>
              <div class="vx-col sm:w-1/5 w-full">
                <vs-input
                  class="w-full"
                  name="ddi"
                  v-model="ddi.ddi"
                  data-vv-as="DDI"
                />
              </div>

              <div class="vx-col sm:w-1/5 w-full">
                <!-- <vs-radio
              v-model="ddi.primary"
              :vs-value="ddi.primary"
              class="mr-4"
              vs-name="primary_ddi"
            ></vs-radio
            > -->

                <vs-icon
                  class="removeButton"
                  @click="removeSelectedDDI(ddi)"
                  color="success"
                  icon="clear"
                >
                </vs-icon>
              </div>
            </div>
          </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">Mobile</h5>
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-button color="primary" @click="addMobile" type="filled"
                >Add</vs-button
              >
            </div>
          </div>

          <template v-for="(mobile, index) in contactDescription.mobiles">
            <div class="vx-row p-2">
              <div class="vx-col sm:w-1/5 w-full">
                <div
                  :class="{
                    correction_field_input_class:
                      correction_fields_array.includes('mobile_phone_code')
                  }"
                >
                  <v-select
                    name="mobile_phone_code"
                    class="mobile_phone_code"
                    label="name_with_code"
                    :options="all_phone_codes"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="mobile.mobile_phone_code"
                  />
                </div>

                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('mobile')"
                  >{{ errors.first('mobile') }}</span
                >
              </div>
              <div class="vx-col sm:w-1/5 w-full">
                <vs-input
                  class="w-full"
                  name="mobile"
                  v-model="mobile.mobile"
                  data-vv-as="Mobile"
                />
              </div>

              <div class="vx-col sm:w-1/5 w-full">
                <!-- <vs-radio
              v-model="mobile.primary"
              :vs-value="mobile.primary"
              class="mr-4"
              vs-name="primary_mobile"
            ></vs-radio
            > -->

                <vs-icon
                  class="removeButton"
                  @click="removeSelectedMobile(mobile)"
                  color="success"
                  icon="clear"
                >
                </vs-icon>
              </div>
            </div>
          </template>
          <vs-divider class="m-10" />

          <div class="vx-row">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3" @click.prevent="submitForm"
                >Add this Contact</vs-button
              >
            </div>
          
          </div>


          

            <div class="vx-col w-full">
              <div class="text-right  mr-20">
                


 <vs-button :disabled="existing_campaign_contact_matches.length == 0 ? true : false" class="build-complete"  @click.prevent="contactBuildComplete"
                >
               Contact Build Complete 
</vs-button
              >          
           
               


              </div>
              
            </div>
        </vs-col>

        <vs-col vs-lg="4" vs-sm="4" vs-xs="12" >
    <div class="m-2  mb-5">
            <u><h4>Existing Campaign Contacts</h4></u>
          </div>

          <div :class="existing_campaign_contact_matches.length > 0 ? scrollClass : ''"
>
              <template v-for="(match, index) in existing_campaign_contact_matches">
                  <p class="p-2">
                    {{ match.title }} {{ match.forename }} {{ match.surname }} - {{ match.job_title }}
                    <!-- <vs-icon
                      @click.stop="viewPotentialMatchContactDetails(match)"
                      size="small"
                      icon="info"
                      style="cursor: pointer; margin-left: 15px"
                    ></vs-icon> -->
                  </p>

              </template>

          </div>



    <div class="m-2 mt-10 mb-5">
            <u><h4>Existing Master Database Contacts</h4></u>
          </div>

          
          <div :class="existing_master_database_contacts.length > 0 ? scrollClass : ''"


          
>

              <template v-for="(match, index) in existing_master_database_contacts">
                  <p>

                    <template v-if="!existed_contact_ids.includes(match.contact_id)">



                  <input class="m-5"
            v-model="match.selected"
              type="checkbox"
            />  
            </template>

          <template v-else>
            <input class="m-5"
              type="checkbox"
              v-model="isChecked"
              checked
              disabled
            />
          </template>


            
            {{ match.title }} {{ match.forename }} {{ match.surname }} - {{ match.job_title }}
                    <vs-icon
                      @click.stop="viewPotentialMatchContactDetails(match)"
                      size="small"
                      icon="info"
                      style="cursor: pointer; margin-left: 15px"
                    ></vs-icon>
                  </p>

              

              </template>

                 <div class="vx-row mb-6" v-if="existing_master_database_contacts.length > 0">
            <div class="vx-col sm:w-1/2 w-full ml-6 mt-5">
              <vs-button  @click.prevent="submitExistingMasterDatabaseContacts"
                >Submit</vs-button
              >
            </div>
          </div>

          </div>



        </vs-col>
      </vs-row>
    </vx-card>

    <vs-popup
      title="Contact Details"
       v-if="showUpdateSContactDetailsPopup"
      :active.sync="updateContactsDetailsPopupActive"
    >
       <div class="ml-5">


        

   
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Title:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
             {{ updateContactDescription.title }}
            </div>

              <div class="vx-col sm:w-2/3 w-full ml-10">
              <span>{{ contactDescription.title }}</span>
            </div>
          
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Forename:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                          {{ updateContactDescription.forename }}

            </div>
           
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Surname:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
               {{ updateContactDescription.surname }}
            </div>
             
           
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Job Title:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full" >
              {{ updateContactDescription.job_title }}
              
            </div>
             
        
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Seniority:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
            {{ updateContactDescription.seniority != undefined && updateContactDescription.seniority.length > 0 ? updateContactDescription.seniority[0].seniority : '' }}
            </div>
           
           
          </div>

   <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Role:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
            {{ updateContactDescription.role != undefined && updateContactDescription.role.length > 0 ? updateContactDescription.role[0].role : '' }}
            </div>
           
           
          </div>


   <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Sub Role:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
            {{ updateContactDescription.sub_role != undefined && updateContactDescription.sub_role.length > 0 ? updateContactDescription.sub_role[0].sub_role : '' }}
            </div>
           
           
          </div>




          <div class="vx-row mb-6">

            <div class="vx-col sm:w-1/6 w-full">
              <h5>Email                  

              </h5>



            </div>
           
          </div>
         

            <template 
            v-for="(email, index) in updateContactDescription.emails"
          >



        
          <div class="vx-row p-2">
            <div class="vx-col sm:w-1/4 w-full">
             {{email.email}}
             
            </div>
         


         
            
            </div>

           
            </template>
        
          <vs-divider class="m-5" />


          <div class="vx-row mb-6">

            <div class="vx-col w-full">
              <h5>Social Media Pages    
              </h5>


            </div>
          
          </div>
         

            <template
            v-for="(social_media, index) in updateContactDescription.social_medias"
          >

        
          <div class="vx-row">
            <div class="vx-col w-full">
            {{ social_media.social_media }} {{ ' - ' + social_media.summary }}
             
            </div>
         

           

  

            
            </div>

           
            </template>
           
        
          <vs-divider class="m-5" />

          <div class="vx-row mb-6">

            <div class="vx-col sm:w-1/6 w-full">
              <h5>DDI
              </h5>


            </div>
         
          </div>
         

            <template
            v-for="(ddi, index) in updateContactDescription.ddis"
          >

        
          <div class="vx-row p-2">
            <div class="vx-col w-full">


              {{ ddi.ddi == null? '' : ddi.ddi_phone_code + ' - ' }}{{ ddi.ddi }}


            
           
            </div>
  

            
            
            </div>

           
            </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">

            <div class="vx-col sm:w-1/6 w-full">
              <h5>Mobile
              </h5>
          
          
            </div>
            <div class="vx-col w-full">
          
          </div>
          </div>
          
          
            <template
            v-for="(mobile, index) in updateContactDescription.mobiles"
          >
          
          
          <div class="vx-row p-2">
            <div class="vx-col w-full">

              {{ mobile.mobile == null? '' : mobile.mobile_phone_code + ' - ' }}{{ mobile.mobile }}
          
          
           
            </div>
       
          
       



     
            
            </div>
          
           
            </template>
            <vs-divider class="m-10" />

  

      </div>
    </vs-popup>


       <vs-popup
      title="Account Details"
       v-if="showUpdateSAccountDetailsPopup"
      :active.sync="updateAccountDetailsPopupActive"
    >

     
      <div class="p-5">


     
 
        <div class="vx-row mb-6" v-if="viewAccountDescription.company_name">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Company Name:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.company_name }}
          </div>
         
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.actual_account_name">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Actual Account Name:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.actual_account_name }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.company_registration_number"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Registration Number:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.company_registration_number }}
          </div>
        </div>
    
        <div class="vx-row mb-6" v-if="viewAccountDescription.status">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Company Status:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.status }}
          </div>
        </div>
                <div class="vx-row mb-6" v-if="viewAccountDescription.company_category">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Company Category:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.company_category }}
          </div>
        </div>
        <div v-if="viewAccountDescription.registered_office_address_1 || viewAccountDescription.registered_office_address_2 || viewAccountDescription.registered_office_address_3 || viewAccountDescription.registered_office_city || viewAccountDescription.registered_office_county || viewAccountDescription.registered_office_country || viewAccountDescription.registered_office_country">
<vs-divider class="m-5" />
        <!-- Registered Office -->
        <h5 class="mb-5 font-bold">Registered Office Address</h5>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_address_1"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold">Address Line 1:</span>
             
            
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_address_1 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_address_2"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Address Line 2:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_address_2 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_address_3"
        >
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              Address Line 3:</span
            >
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_address_3 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_city"
        >
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              City:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_city }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_county"
        >
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              County:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_county }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_postcode"
        >
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              Postcode:</span
            >
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_postcode }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_country"
        >
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              Country:</span
            >
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_country }}
          </div>
        </div>

        <!-- Head Office -->
        <div v-if="viewAccountDescription.head_office_address_1 || viewAccountDescription.head_office_address_2 || viewAccountDescription.head_office_address_3 || viewAccountDescription.head_office_city || viewAccountDescription.head_office_county   || viewAccountDescription.head_office_postcode || viewAccountDescription.head_office_country">
                <vs-divider class="m-5" />
        <h5 class="mb-5 font-bold">Head Office Address</h5>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.head_office_address_1"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Address Line 1:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_address_1 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.head_office_address_2"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Address Line 2:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_address_2 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.head_office_address_3"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Address Line 3:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_address_3 }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_city">
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              City:</span
            >
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_city }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_county">
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              County:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_county }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_postcode">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Postcode:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_postcode }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_country">
    <div class="vx-col sm:w-1/3 w-full">
     <span class="font-bold"
              >
        
        Country:
      </span>
    </div>
    <div class="vx-col sm:w-2/3 w-full">
      {{ viewAccountDescription.head_office_country }}
    </div>
  </div>
        <!-- <vs-divider class="m-5" /> -->
        <template
          v-if="viewAccountDescription.web && viewAccountDescription.web.length > 0"
        >
          <div class="vx-row p-5">
            <h6 class="mr-5 font-bold">
             
              Company Website(s)
            </h6>
      
          </div>
          <div
            v-for="(website, web_key) in viewAccountDescription.web"
            :key="web_key"
          >
            <span>
              <p>{{ website.url }}</p>
            </span>
          </div>
          <vs-divider class="m-5" />
        </template>

        <template
          v-if="
            viewAccountDescription.linkedin &&
              viewAccountDescription.linkedin.length > 0
          "
        >
          <div class="vx-row p-5">
            <h6 class="mr-5 font-bold">
             
              Social Media Pages
            </h6>
           
          </div>
          <div
            v-for="(link, linkedin_key) in viewAccountDescription.linkedin"
            :key="linkedin_key"
          >
            <span>
              <p>{{ link.url }}</p>
            </span>
          </div>
          <vs-divider class="m-5" />
        </template>

        <!-- Site Office -->
        <template
          v-if="
            viewAccountDescription.satellite_office &&
              viewAccountDescription.satellite_office.length > 0
          "
        >
          <h5 class="mb-5 font-bold">Site Office Address</h5>
          <template
            v-for="(site, index) in viewAccountDescription.satellite_office"
          >
            <div :key="index">
              <vs-divider class="m-5" />
              <h6 class="mb-5 font-bold">{{ "Satellite Office " + (index + 1) }}</h6>
              <div class="vx-row mb-6" v-if="site.address_1">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    Address Line 1:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.address_1 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.address_2">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    Address Line 2:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.address_2 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.address_3">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    Address Line 3:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.address_3 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.city">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    City:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.city }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.county">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    County:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.county }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.postcode">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    Postcode:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.postcode }}</div>
              </div>
                <div class="vx-row mb-6" v-if="site.country">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    Country:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.country }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.phone.length != 0">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                   
                    Telephone:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <template v-for="(phone, key) in site.phone">
                    <div :key="key" v-if="phone.satellite_office_id == site.id">
                      {{ phone.phone_code }} - {{ phone.phone_no }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
                  <vs-divider class="m-5" />
        </template>

        <!-- Telephone -->
        <template
          v-if="viewAccountDescription.phone && viewAccountDescription.phone.length > 0"
        >
          <div class="vx-row p-5">
            <h6 class="mr-5 font-bold">
              
              Telephone Number(s)
            </h6>
           
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <template v-for="phone in viewAccountDescription.phone">
                <template v-for="p_type in phone.phone_type">
                  <template v-if="phone.id == p_type.phone_id">
                    <!-- <template v-if="p_type.type == 'head_office_switchboard'"> -->
                      <p class="m-2">

                        {{p_type.type}} : {{ phone.phone_code }}{{ phone.phone_no }} 
                        <span v-if="phone.checked_status == 'Registered'" class="tps-registered" style="font-size:20px;" title="TPS Registered">®</span> 

                      </p>
                    <!-- </template>
                    <template v-if="p_type.type == 'customer_service'">
                      <p class="m-10">
                        Customer Service - {{ phone.phone_no }}
                      </p>
                    </template>

                    <template v-if="p_type.type == 'sales_line'">
                      <p class="m-10">Sales Line - {{ phone.phone_no }}</p>
                    </template>

                    <template v-if="p_type.type == 'customer_support_line'">
                      <p class="m-10">
                        Customer Support Line - {{ phone.phone_no }}
                      </p>
                    </template> -->
                  </template>
                </template>
              </template>
            </div>
            <div class="vx-col sm:w-2/3 w-full"></div>
          </div>
        </template>
        <!-- SIC CODE -->
         <template
          v-if="viewAccountDescription.sic_code && viewAccountDescription.sic_code.length > 0"
        >
          <div class="vx-row p-5">
            <h6 class="mr-5 font-bold">
             
              Sic Code(s)
            </h6>
          
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <template v-for="sic in viewAccountDescription.sic_code">
                <p  v-if="sic.sic_code_detail">
                  {{ sic.sic_code_detail.code }} {{ ' - ' +  sic.sic_code_detail.description }}
                </p>
              </template>
            </div>
            <div class="vx-col sm:w-2/3 w-full"></div>
          </div>
        </template>
        <template
          v-if="
            viewAccountDescription.registration_jurisdiction ||
              viewAccountDescription.parent ||
              viewAccountDescription.vertical
          "
        >
          <h5 class="mb-5">Other Details</h5>
          <div
            class="vx-row mb-6"
            v-if="viewAccountDescription.registration_jurisdiction"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span class="font-bold"
              >
                Registration Jurisdiction:</span
              >
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ RegistrationJurisdiction }}
              <!-- {{ viewAccountDescription.registration_jurisdiction }} -->
            </div>
          </div>
          <div class="vx-row mb-6" v-if="viewAccountDescription.parent">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="font-bold"
              >
                Parent:</span
              >
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ parent_name }}
            </div>
          </div>
          <div class="vx-row mb-6" v-if="viewAccountDescription.vertical">
            <div class="vx-col sm:w-1/3 w-full">
             <span class="font-bold"
              >
                Vertical:</span
              >
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <!-- {{ viewAccountDescription.vertical }} -->
              {{ verticalName }}
            </div>
          </div>
        </template>
        <div class="vx-row mb-6" v-if="viewAccountDescription.revenue">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Revenue:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.currency_name }} {{ viewAccountDescription.revenue }}
          </div>
        </div>
          <div class="vx-row mb-6" v-if="viewAccountDescription.no_of_employees">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              No of Employees:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.no_of_employees }} 
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.notes">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Notes:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.notes }} 
          </div>
        </div>
       
      </div>
       

     
    </vs-popup>
    <vs-popup
      title="List of contacts Matched By Email"
      :active.sync="MatchedEmailPopupActive"
    >
      <div>
        <vs-list>
          <template v-for="(match, index) in matched_emails">
            <vs-list-item :key="index">
              <p class="p-2">
                {{ match.title }} {{ match.forename }} {{ match.surname }}
                <vs-icon
                  @click.stop="viewPotentialMatchContactDetails(match)"
                  size="small"
                  icon="info"
                  style="cursor: pointer; margin-left: 15px"
                ></vs-icon>
              </p>
              <p class="p-2">{{ match.job_title }}</p>
              <p class="p-2">{{ match.email }}</p>
              <p class="p-2">{{ match.social_media }}</p>
              <p class="p-2">{{ match.role }}</p>
              <p class="p-2">{{ match.seniority }}</p>
            </vs-list-item>
          </template>

          <div class="vx-row mt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button @click="AddEmailAnyWay()" class="mr-3 mb-2"
                >Submit</vs-button
              >

              <vs-button @click="CancelEmailPopup()" class="mr-3 mb-2"
                >Cancel</vs-button
              >
            </div>
          </div>
        </vs-list>
      </div>
    </vs-popup>

    <vs-popup
      title="List of contacts Matched By Social Media"
      :active.sync="MatchedSocialMediaPopupActive"
    >
      <div>
        <vs-list>
          <template v-for="(match, index) in matched_social_medias">
            <vs-list-item :key="index">
              <p class="p-2">
                {{ match.title }} {{ match.forename }} {{ match.surname }}
                <vs-icon
                  @click.stop="viewPotentialMatchContactDetails(match)"
                  size="small"
                  icon="info"
                  style="cursor: pointer; margin-left: 15px"
                ></vs-icon>
              </p>
              <p class="p-2">{{ match.job_title }}</p>
              <p class="p-2">{{ match.email }}</p>
              <p class="p-2">{{ match.social_media }}</p>
              <p class="p-2">{{ match.role }}</p>
              <p class="p-2">{{ match.seniority }}</p>

              <vs-divider class="m-5" />
            </vs-list-item>
          </template>

          <div class="vx-row mt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button @click="AddSocialMediaAnyWay()" class="mr-3 mb-2"
                >Submit</vs-button
              >

              <vs-button @click="CancelSocialMediaPopup()" class="mr-3 mb-2"
                >Cancel</vs-button
              >
            </div>
          </div>
        </vs-list>
      </div>
    </vs-popup>

    <vs-popup
      title="Very Close Matches Found In Database"
      :active.sync="MatchedContactsPopupActive"
    >
      <div>
        <vs-list>
          <template v-for="(match, index) in submit_match_contacts">
            <vs-list-item :key="index">
              <p class="p-2">
                {{ match.title }} {{ match.forename }} {{ match.surname }}
                <vs-icon
                  @click.stop="viewPotentialMatchContactDetails(match)"
                  size="small"
                  icon="info"
                  style="cursor: pointer; margin-left: 15px"
                ></vs-icon>
              </p>
              <p class="p-2">{{ match.job_title }}</p>
              <p class="p-2">{{ match.email }}</p>
              <p class="p-2">{{ match.social_media }}</p>
              <p class="p-2">{{ match.role }}</p>
              <p class="p-2">{{ match.seniority }}</p>

            </vs-list-item>
          </template>


            <div class="vx-row mt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button @click="submitFormAnyway()" class="mr-3 mb-2"
                >Submit</vs-button
              >

              <vs-button @click="cancelSubmitFormAnyway()" class="mr-3 mb-2"
                >Cancel</vs-button
              >
            </div>
          </div>
        </vs-list>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moduleContactsManagement from '@/store/contacts-management/moduleContactsManagement.js'
import moduleAccountsManagement from '@/store/accounts-management/moduleAccountsManagement.js'
import _ from 'lodash'
import defineAbilitiesFor from '@/config/abilities'
import axios from '@/axios.js'
import moduleCampaignsManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import AccountAutocomplete from '@/components/autocomplete/AccountsAutocompleteDisabled.vue'
import Autocomplete from '@/components/autocomplete/Autocomplete.vue'
import vSelect from 'vue-select'
import ProgressBar from 'vue-simple-progress'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { remove } from 'lodash'
export default {
  components: {
    Autocomplete,
    'v-select': vSelect,
    ProgressBar,
    flatPickr,
    AccountAutocomplete
  },
  computed: {
    total_pages () {
      console.log('totla', this.all_total)
      return Math.ceil(this.all_total / this.limit)
    }
    // cloneItems() {
    //     var clone = this.unmatch_contacts;
    //     var startFrom = (this.pagination.page*this.pagination.rowsPerPage)-this.pagination.rowsPerPage;
    //     return clone.splice(startFrom, this.pagination.rowsPerPage);
    // }
  },
  data () {
    return {
      isChecked: true,
      existed_contact_ids: [],
            RegistrationJurisdiction: null,
      viewAccountDescription: {},
    showUpdateSAccountDetailsPopup: false,
      updateAccountDetailsPopupActive: false,
      selected_existing_master_database_contacts: [],
      scrollClass: 'scroll-container',
      existing_master_database_contacts: [],
    existing_campaign_contact_matches: [],
      showUpdateSContactDetailsPopup: false,
            showAddressField: false,

            account_validation: null,
      updateContactDescription: {},
      updateContactsDetailsPopupActive: false,
      editContacts: {
        account_id: null,
        primary_social_media: null,
        primary_mobile: null,
        primary_ddi: null,

        edit_primary_email: null,
        company_name: null,
        social_medias: [],
        mobiles: [],
        ddis: [],

        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        mobile: null,
        ddi: null,

        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
        seniorities: [],
        sub_roles: [],
        satellite_address: {},
        satellite_office_id: null
      },

      email_validate_status: null,
      contact_validation: null,
      companySearchComponentKey: 0,
      update_contact_and_add_to_campaign_heading:
        'Update contact and Add to Campaign',
      subsidiaryPopupActive: false,
      temp_table_id: null,
      submit_match_contacts: [],
      MatchedContactsPopupActive: false,
      MatchedEmailPopupActive: false,
      MatchedSocialMediaPopupActive: false,
      subsidiarycontactDescription: {},
      updateSatelliteOfficecontactDescription: {},
      all_phone_codes: [],
      head_office_country_validation: null,
      matched_emails: [],
      matched_social_medias: [],
      user_id: null,
      user_role: null,
      registered_office_country_validation: null,
      selected_parent_company: null,
      selected_registration_jurisdiction: null,
      selected_vertical: null,
      selected_sic_code: null,
      selected_registered_office_country: null,
      selected_head_office_country: null,
      satellite_office_currency_code_validation: null,
      currencyCodes: [],
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      popupActive: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      headOfficeIsRegisteredOffice: false,
      satelliteOfficeheadOfficeIsRegisteredOffice: false,
      subsidiaryheadOfficeIsRegisteredOffice: false,
      overwriteDataBuildRegisteredOfficeAddressToMasterDB: false,
      overwriteDataBuildHeadOfficeAddressToMasterDB: false,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_head_office_address_1_update_satellite_office: null,
      old_head_office_address_2_update_satellite_office: null,
      old_head_office_address_3_update_satellite_office: null,
      old_head_office_city_update_satellite_office: null,
      old_head_office_county_update_satellite_office: null,
      old_head_office_postcode_update_satellite_office: null,
      old_head_office_country_update_satellite_office: null,
      old_registered_office_address_1_update_satellite_office: null,
      old_registered_office_address_2_update_satellite_office: null,
      old_registered_office_address_3_update_satellite_office: null,
      old_registered_office_city_update_satellite_office: null,
      old_registered_office_county_update_satellite_office: null,
      old_registered_office_postcode_update_satellite_office: null,
      old_registered_office_country_update_satellite_office: null,
      old_head_office_address_1_subsidiary: null,
      old_head_office_address_2_subsidiary: null,
      old_head_office_address_3_subsidiary: null,
      old_head_office_city_subsidiary: null,
      old_head_office_county_subsidiary: null,
      old_head_office_postcode_subsidiary: null,
      old_head_office_country_subsidiary: null,
      old_registered_office_address_1_subsidiary: null,
      old_registered_office_address_2_subsidiary: null,
      old_registered_office_address_3_subsidiary: null,
      old_registered_office_city_subsidiary: null,
      old_registered_office_county_subsidiary: null,
      old_registered_office_postcode_subsidiary: null,
      old_registered_office_country_subsidiary: null,
      old_company_registration_number: null,
      IsSoleTrader: false,
      registered_office_country_validation: null,
      head_office_country_validation: null,

      configDatePicker: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        allowInvalidPreload: false
      },
      configDateAndTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:s',
        allowInvalidPreload: false,
        enableSeconds: true
      },
      PLeasewait: '',
      uploadPercentage: 0,
      all_unmatched_contacts: [],
      selected: [],
      allSelected: false,
      all_currency_codes: [],
      all_verticals: [],
      all_sic_codes: [],
      all_countries: [],
      contactDescription: {},
      mandatory_fields: [],
      all_phone_codes: [],
      selected_fields: null,
      phoneTypes: [],
      correction_fields_array: [],
      vertical: null,
      selected_vertical: null,
      correction_fields: null,
      selected_registration_jurisdiction: null,
      currencyCodes: [],
      selected_sic_code: null,
      add_or_update_title: null,
      user_id: null,
      user_role: null,
      selected_head_office_country: null,
      abilities: null,
      field_array_columns: [],
      actual_contact_name: null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      company_category: null,
      sic_code: null,
      revenue: null,
      currency_code: null,
      registration_jurisdiction: null,
      no_of_employees: null,
      // sic_code_description: null,
      phone_type: null,
      phone_no: null,
      phone_code: null,
      website: null,
      linkedin: null,
      status: null,
      switchboard: null,
      switchboard_phone_code: null,
      site_switchboard: null,
      site_switchboard_phone_code: null,
      company_name: null,
      selected_fields: null,
      registered_office_country_validation: null,
      EnhancedHeadOfficeAutocompleteComponentKey: 0,
      EnhancedRegOfficeAutocompleteComponentKey: 0,
      EnhancedSicCodeAutocompleteComponentKey: 0,
      EnhancedVerticalAutocompleteComponentKey: 0,
      EnhancedRegistrationJurisdictionAutocompleteComponentKey: 0,
      company_registration_number: null,
      country: null,
      isNewcontact: null,
      update_id: null,
      table: null,
      popupActive: false,
      updateData: [],
      currency_code_validation: null,
      currencyCodes: [],
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      contactExists: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_company_registration_number: null,
      contacts: {
        account_id: null,
        primary_social_media: null,
        primary_mobile: null,
        primary_ddi: null,

        primary_email: null,
        company_name: null,
        social_medias: [],
        mobiles: [],
        ddis: [],

        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        mobile: null,
        ddi: null,

        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
        seniorities: [],
        sub_roles: [],
        satellite_address: {},
        satellite_office_id: null
      },
      addNewcontactsPopUp: false,
      campaignDescription: [],
      abilities: null,
      campaignId: null,
      componentKey: 0,
      limit: 1,
      currentx: 1,
      paginate: { limit: 1, offset: 0 },
      tableData: [],
      header: [],
      sheetName: '',
      list2: [],
      uploaded_columns: [],
      selected_fields: [
        'ml_company',
        'ml_actual_contact_name',
        [
          [
            'Head Office Address',
            'Registered Office',
            'State',
            'Town',
            'Country',
            'Postal Code',
            'Site Office'
          ]
        ]
      ],
      unmatch_contacts: [],
      accept_text: 'Accept',
      acceptButtonColor: 'primary',
      accepted_matches: [],
      combined_matches: [],
      all_total: 0
    }
  },
  mounted () {
    this.unmatchedIndividualBuildDataById()
    this.getCampaignDescription()
    this.getSeniority()
    this.getRoles()
    this.getAllPhoneCodes()
  },
  watch: {
    'contactDescription.role' (val) {
      this.contactDescription.sub_roles = []

      if (val) {
        if (val.id !== undefined) {
          this.getSubRole(val.id)
        } else {
          this.getSubRoleByName(val)
        }
      }
    },
    currentx: function (val, oldVal) {
      this.unmatch_contacts = this.all_unmatched_contacts.slice(
        (val - 1) * this.limit,
        val * this.limit
      )

      console.log('currentx', val)

      this.writeMasterDatabaseAndMatch(this.all_unmatched_contacts[val - 1])
    }
  },
  methods: {
  submitFormAnyway(){

    this.addContactsAnyway()

  },
  cancelSubmitFormAnyway(){
    this.MatchedContactsPopupActive = false
  },
     updateContactDescriptionForm () {
      this.$vs.loading()

      

    



   

      this.updateContactDescription.user_id = this.user_id

      this.updateContactDescription.campaign_id =
        this.$route.params.campaignId

      this.updateContactDescription.table_id = this.temp_table_id

      this.updateContactDescriptionAndAddToCampaign()

      this.$vs.loading.close()
    },
    updateContactDescriptionAndAddToCampaign () {
      let self = this
      self.$store
        .dispatch(
          'contactsManagement/updateContactDescriptionAndAddToCampaign',
          self.updateContactDescription
        )
        .then(res => {
          if (res.data.status == 'fail') {
            self.addNonExistingAccountToCampaignAccountTable()
          } else {
            

            let result_data = res.data.data

console.log(
              'Updated Contact Description and Added to Campaign',
              result_data
            )

            self.contactDescription.contact_id = result_data.id
            self.contactDescription.campaign_id = self.$route.params.campaignId

            self.AddMatchedNoneCoreFields()

      self.MatchedEmailPopupActive = false

      self.MatchedSocialMediaPopupActive = false

      self.MatchedContactsPopupActive = false

          self.updateContactsDetailsPopupActive = false
      


            


            self.matchedData()

            

            

          }
        })
        .catch(err => {
          console.log(err)

          if (err.response.status === 401) {
            self.$router.replace('/login')
          }
        })
    },
     matchedData() {
    let self = this;
      this.$vs.loading()

      this.paginate.campaignId = self.$route.params.campaignId


      if (self.contactDescription.id == undefined || self.contactDescription.id == null) {

        self.paginate.buildId = self.updateContactDescription.table_id
      }else{
        self.paginate.buildId = self.contactDescription.id
      }

      axios
        .post(
          this.$base_url + "/api/contacts/enrich_data_build_contact_data_to_masterdatabase",
          this.paginate
        )
        .then(response => {

          console.log("RESS" , JSON.parse(response.data));


          let match_contacts = JSON.parse(response.data).rows;

          if (match_contacts.length > 0) {


        self.$router.push(
              '/contacts/enrichDataBuildContactDataToMasterDb/' +
                self.$route.params.campaignId + '/' +
                self.paginate.buildId
            )


          }else{


            this.$router.go(0);
          }


         





        
        })
        .catch(error => {
          console.log(error);
        });
    },
    cancelContactDescriptionForm () {
      let self = this

       self.MatchedEmailPopupActive = false

      self.MatchedSocialMediaPopupActive = false

      self.MatchedContactsPopupActive = false

          self.updateContactsDetailsPopupActive = false
      self.$validator.errors.clear()
    },
     validateUpdateContactDescriptionEmailZeroBounce(email){
      let self = this

        self.$vs.loading();

        this.$store
        .dispatch("contactsManagement/validateEmailZeroBounce", email)
        .then(res => {
          self.email_validate_status = res.data
          self.$vs.loading.close();

         console.log(res)
        })
        .catch(err => {
          console.error(err);
        });


     

    },
    addUpdateContactDescriptionSocialMedia() {
      this.updateContactDescription.social_medias.push({
          social_media: null,
          summary: null,
          primary: false

        });
    },
    addUpdateContactDescriptionEmail() {
  this.updateContactDescription.emails.push({
      email: null,
      primary: false

    });
},
addUpdateContactDescriptionDDI() {
  this.updateContactDescription.ddis.push({
      ddi: null,
      ddi_phone_code: null,
      primary: false

    });
},
    addUpdateContactDescriptionMobile() {
      this.updateContactDescription.mobiles.push({
          mobile: null,
          mobile_phone_code: null,
          primary: false

        });
    },

    removeSelectedUpdateContactDescriptionSocialMedia(social_media) {
      this.updateContactDescription.social_medias = this.updateContactDescription.social_medias.filter(
        item => {
          return item != social_media;
        }
      );
    },
    removeSelectedUpdateContactDescriptionEmail(email) {
      this.updateContactDescription.emails = this.updateContactDescription.emails.filter(
        item => {
          return item != email;
        }
      );
    },
    removeSelectedUpdateContactDescriptionMobile(mobile) {
      this.updateContactDescription.mobiles = this.updateContactDescription.mobiles.filter(
        item => {
          return item != mobile;
        }
      );
    },
    removeSelectedUpdateContactDescriptionDDI(ddi) {
    this.updateContactDescription.ddis = this.updateContactDescription.ddis.filter(
      item => {
        return item != ddi;
      }
    );
  },
   
    viewPotentialMatchContactDetails (contact) {


      // return false
      let self = this

          self.showUpdateSContactDetailsPopup = true

      // self.$validator.errors.clear()
      self.update_contact_and_add_to_campaign_heading =
        'Matched Contact Details'
      let updateContactDetail = { contact_id: contact.contact_id  , account_id: contact.account_id }
      this.$store
        .dispatch(
          'contactsManagement/fetchContact',
          updateContactDetail
        )
        .then(res => {
          this.updateContactDescription = res.data



          //     this.$refs.updateContactCompanyRef.$refs.suggestComponent.input.value =
          //   this.updateContactDescription.company_name
          // this.$refs.updateContactCompanyRef.$refs.suggestComponent.value =
          //   this.updateContactDescription.company_name


          console.log(
            "Previous Account Contact Description",
            self.updateContactDescription
          );


          if (self.updateContactDescription.role) {
            self.updateContactDescription.role.forEach(function(ele) {
              ele.id = ele.uuid;
              return ele;
            });
          }

          if (self.updateContactDescription.sub_role) {
            self.updateContactDescription.sub_role.forEach(function(ele) {
              ele.id = ele.uuid;
              return ele;
            });
          }

          if (self.updateContactDescription.seniority) {
            self.updateContactDescription.seniority.forEach(function(ele) {
              ele.id = ele.uuid;
              return ele;
            });
          }

          if (self.updateContactDescription.emails) {
            self.updateContactDescription.emails.forEach(function(ele) {
              if (ele.primary == true) {
                self.updateContactDescription.primary_email = ele.email;
              }
              return ele;
            });
          }

          if (self.updateContactDescription.social_medias) {
            self.updateContactDescription.social_medias.forEach(function(ele) {
              if (ele.primary == true) {
                self.updateContactDescription.primary_social_media = ele.social_media;
              }
              return ele;
            });
          }

          if (self.updateContactDescription.mobiles) {
            self.updateContactDescription.mobiles.forEach(function(ele) {
              if (ele.primary == true) {
                self.updateContactDescription.primary_mobile = ele.mobile;
              }
              return ele;
            });
          }

          if (self.updateContactDescription.ddis) {
    self.updateContactDescription.ddis.forEach(function(ele) {
      if (ele.primary == true) {
        self.updateContactDescription.primary_ddi = ele.ddi;
      }
      return ele;
    });
  }

          if (self.updateContactDescription.job_title) {
            if (Array.isArray(self.updateContactDescription.job_title)){
              self.updateContactDescription.job_title =
              self.updateContactDescription.job_title[0]["job_title"];
            }
          
          }

          // self.getSubRole(self.updateContactDescription.role[0].id);



          
         

          // this.$refs.SatelliteOfficecontactEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          //   this.updateContactDescription.head_office_country
          // this.$refs.SatelliteOfficecontactEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          //   this.updateContactDescription.head_office_country

        

         

      

        


      self.MatchedEmailPopupActive = false

      self.MatchedSocialMediaPopupActive = false

      self.MatchedContactsPopupActive = false

          self.updateContactsDetailsPopupActive = true
          })

    },
    getAllPhoneCodes () {
      let self = this
      this.$store
        .dispatch('accountsManagement/getAllPhoneCodes')
        .then(response => {
          self.all_phone_codes = response.data
          self.all_phone_codes.forEach(function (ele) {
            if (ele.phone_code) {
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })

          console.log('all_phone_codes', self.all_phone_codes)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    validDomain (userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        )
        if (res == null) {
          return false
        }
      }
      return true
    },
    editSubmitForm () {
      // console.log(this.editContactDescription)
      // return false

      let self = this
      if (this.editContactDescription.edit_primary_email) {
        this.editContactDescription.primary_email =
          this.editContactDescription.edit_primary_email
      }
      // if (
      //   self.edit_accounts.length === 0 &&
      //   self.editContactDescription.company_name == null
      // ) {
      //   self.edit_contact_validation = "The Account field is required";
      //   return false;
      // } else {
      //   if (self.edit_accounts.length != 0) {
      //     self.editContactDescription.account_id = self.edit_accounts[0].id;
      //   }
      //   self.updateEditContact();
      // }

      this.$validator.validateAll('popup-edit-form').then(result => {
        // console.log(this.editContactDescription.company_name);
        if (result) {
          if (
            self.edit_accounts.length === 0 &&
            self.editContactDescription.company_name == null
          ) {
            self.edit_contact_validation = 'The Account field is required'
            return false
          } else {
            if (self.edit_accounts.length != 0) {
              self.editContactDescription.account_id = self.edit_accounts[0].id
            }
            self.updateEditContact()
          }

          // if form have no errors
        } else {
          return false
        }
      })
    },
    updateEditContact () {
      if (Array.isArray(this.editContactDescription.role)) {
        this.editContactDescription.role = this.editContactDescription.role[0]
      }

      if (Array.isArray(this.editContactDescription.sub_role)) {
        this.editContactDescription.sub_role =
          this.editContactDescription.sub_role[0]
      }

      if (Array.isArray(this.editContactDescription.seniority)) {
        this.editContactDescription.seniority =
          this.editContactDescription.seniority[0]
      }

      // if (Array.isArray(this.editContactDescription.job_title)) {
      //   this.editContactDescription.job_title = this.editContactDescription.job_title[0];
      // }

      //       console.log("sfsdfsdf" , this.editContactDescription)
      // return false

      if (Object.keys(this.editContacts.satellite_address).length != 0) {
        this.editContactDescription.satellite_office_id =
          this.editContacts.satellite_address.uuid
      } else {
        this.editContactDescription.satellite_office_id = null
      }
      this.$store
        .dispatch(
          'contactsManagement/updateContact',
          this.editContactDescription
        )
        .then(res => {
          if (res.data.status == 'success') {
            this.$refs.EditEmailExistsInDb.gridApi.refreshServerSide({
              purge: true
            })

            this.editContactShowPopup = false
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    editContact () {
      this.viewContactpopupActive = false
      let contactId = this.contactDescription.uuid
      this.editInit(contactId)
      this.editContactShowPopup = true

      // let route = this.$router.resolve("/contacts/edit/" + contactId); // This also works.
      // window.open(route.href, "_blank");

      // this.$router.replace("edit/" + this.contactDescription.id);
      // this.$router.push({ path: `edit/${contactId}` });
    },
    editContactpopup (contact) {
      let contactId = contact.contact_id
      this.editInit(contactId)
      this.editContactShowPopup = true
    },
    viewContactDetails (contactId) {
      this.$store
        .dispatch('contactsManagement/fetchContact', contactId)
        .then(res => {
          this.viewContactDescription = res.data
          this.viewContactpopupActive = true
        })
        .catch(err => {
          console.error(err)
        })
    },
    viewContactpopup (contact) {
      this.viewContactDetails(contact.contact_id)
    },
    closeThisWindow () {
      let self = this
      self.viewContactpopupActive = false
    },
    removeSelectedSocialMedia (social_media) {
      this.contactDescription.social_medias =
        this.contactDescription.social_medias.filter(item => {
          return item != social_media
        })
    },
    removeSelectedEmail (email) {
      this.contactDescription.emails = this.contactDescription.emails.filter(
        item => {
          return item != email
        }
      )
    },
    removeSelectedMobile (mobile) {
      this.contactDescription.mobiles = this.contactDescription.mobiles.filter(
        item => {
          return item != mobile
        }
      )
    },
    removeSelectedDDI (ddi) {
      this.contactDescription.ddis = this.contactDescription.ddis.filter(
        item => {
          return item != ddi
        }
      )
    },
    handleChildEvent () {
      this.satellite_offices = []
      this.accounts = moduleAccountsManagement.state.accounts.datas
      this.contactDescription.account_id = this.accounts[0].id
    },
    searchAccount (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getCompanyOrRegistrationNo', inputValue)
        .then(response => {
          if (response) {
            let data = moduleAccountsManagement.state.company_or_registration_no
            if (data) {
              console.log(data)
              let mappedArray = []
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    ' - ' +
                    data[property].company_registration_number
                })
              }
              return mappedArray
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getSeniority () {
      this.$store
        .dispatch('contactsManagement/getSeniority')
        .then(res => {
          this.contacts.seniorities = res.data
          // console.log(this.contacts.seniorities);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getRoles () {
      this.$store
        .dispatch('contactsManagement/getRoles')
        .then(res => {
          this.contacts.roles = res.data
          // console.log("Roles", this.contacts.roles);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getSubRole (role_id) {
      // alert(role_id)
      // if(!role_id){
      // this.contactDescription.sub_role = null

      // }
      this.$store
        .dispatch('contactsManagement/getSubRoles', role_id)
        .then(res => {
          this.contacts.sub_roles = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    getSubRoleByName (role_name) {
      // alert(role_id)
      // if(!role_id){
      // this.contactDescription.sub_role = null

      // }
      this.$store
        .dispatch('contactsManagement/getSubRolesByName', role_name)
        .then(res => {
          this.contacts.sub_roles = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    goBack: function () {
      this.$router.push('/data_build/build_accounts_list_that_have_no_contacts/' + this.$route.params.campaignId)
    },
    removeSelectedPhone (selected) {
      this.contacts.joinedPhoneAndTypes =
        this.contacts.joinedPhoneAndTypes.filter(item => {
          return item != selected
        })
    },
    validDomain (userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        )
        if (res == null) {
          return false
        }
      }
      return true
    },

    validateEmailZeroBounce (email) {
      let self = this

      if (email != null && email != '') {
        self.$vs.loading()

        this.$store
          .dispatch('contactsManagement/validateEmailZeroBounce', email)
          .then(res => {
            self.email_validate_status = res.data
            self.$vs.loading.close()

            self.addEmail()

            console.log(res)
          })
          .catch(err => {
            self.$vs.loading.close()

            console.error(err)
          })
      }
    },
    addDDI () {


      this.contactDescription.ddis.push({
        ddi: null,
        ddi_phone_code: null,
        primary: false
      })
    },
    addMobile () {
      this.contactDescription.mobiles.push({
        mobile: null,
        mobile_phone_code: null,
        primary: false
      })
    },
     submitExistingMasterDatabaseContacts () {


      this.selected_existing_master_database_contacts = []

       this.existing_master_database_contacts.forEach((contact) => {
        if (contact.selected){
          contact.campaign_id = this.$route.params.campaignId
          contact.table_id = this.contactDescription.id
          contact.user_id = this.user_id
          this.selected_existing_master_database_contacts.push(contact)
        }
       })


              console.log(this.selected_existing_master_database_contacts)



           


               this.$store
        .dispatch(
          'contactsManagement/buildExistingMasterDatabaseContactsToCampaign',
          this.selected_existing_master_database_contacts
        )
        .then(res => {

        if (res.data.status == 'success') {
            this.$vs.notify({
              color: 'success',
              title: 'contact Added',
              text: 'The contact was added successfully'
            })

            this.$router.go(0)
          }

        
        })
        .catch(err => {
          console.log(err)
        })


  //     let self = this
  //     self.$validator.errors.clear()


  //  self.$validator.validateAll().then(result => {
  //       if (result) {
  //          self.contactDescription.user_id = this.user_id
  //     self.contactDescription.campaign_id = this.$route.params.campaignId
  //     self.contactDescription.table_id = this.temp_table_id
  //     self.contactDescription.id = this.temp_table_id
  //     self.addcontacts()
  //       } else {
  //          self.$vs.loading.close()

  //       }
  //                 self.$vs.loading.close()

  //     })
     
    },
    submitForm () {
     

      let self = this
      self.$validator.errors.clear()


   self.$validator.validateAll().then(result => {
        if (result) {
           self.contactDescription.user_id = this.user_id
      self.contactDescription.campaign_id = this.$route.params.campaignId
      self.addcontacts()
        } else {
           self.$vs.loading.close()

        }
                  self.$vs.loading.close()

      })
     
    },

        contactBuildComplete () {
          let self = this
      self.contactDescription.user_id = this.user_id
      self.contactDescription.campaign_id = this.$route.params.campaignId


            this.$store
        .dispatch(
          'contactsManagement/contactBuildComplete',
          self.contactDescription
        )
        .then(res => {

        if (res.data.status == 'success') {
           

            this.$router.push(
              '/data_build/build_accounts_list_that_have_no_contacts/' +
                this.$route.params.campaignId
            )
          }

        
        })
        .catch(err => {
          console.log(err)
        })
     
    },

  


    acceptAlert () {
      this.addNewcontactsPopUp = true
    },
    writeMasterDatabaseAndMatch (data) {
      this.correction_fields_array = []

       this.$validator.errors.clear()
      this.isNewcontact = 'Y'
      this.add_or_update_title = 'Please update the field and submit'

      this.contactDescription = data


      this.contactDescription.id = data.id
      this.temp_table_id = data.id


      

      this.contactDescription.emails = []
      this.contactDescription.social_medias = []
      // this.contactDescription.mobiles = []
      // this.contactDescription.ddis = []




      this.addNonExistingAccountToCampaignAccountTable()


      this.getExistingCampaignContactMatches()

      this.getExistingMasterDatabaseContactsMatches()

      this.getCorrectionFields()

      this.addNewcontactsPopUp = true
    },

    forceRerender () {
      this.componentKey += 1
    },
    getCampaignDescription () {
      const campaignId = this.$route.params.campaignId
      this.$store
        .dispatch('campaignsManagement/fetchCampaign', campaignId)
        .then(res => {
          this.campaignDescription = res.data
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true
            return
          }
          console.error(err)
        })
    },
 
  
 
 
    // checkDuplicateExists() {
    //   let self = this;
    //   self.paginate.campaignId = self.campaignId;
    //   axios
    //     .post(
    //       this.$base_url + "/api/contacts/deduplicate_csv_contacts_data",
    //       self.paginate
    //     )
    //     .then(response => {
    //       let result = JSON.parse(response.data);

    //       if (result.length == 0) {

    //         self.$router
    //           .push(
    //             "/contacts/optionsAfterImportcontactToCampaign/" +
    //             self.campaignId
    //           )
    //           .catch(() => { });
    //           this.$vs.loading.close();

    //       } else {
    //         this.deduplicateOldNewCSV();
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    updateOtherFieldDataToMasterDb () {
      let self = this

      self.$vs.dialog({
        color: 'primary',
        title: `Import None Core Fields`,
        text: 'You are about to import non-core fields to the database.  After you click accept this process will start.  You will receive an email once this process has completed. ',
        accept: this.acceptAlert
      })
    },
    acceptAlert () {
      let self = this
      let data = {}
      data.campaign_id = this.campaignId
      axios
        .post(
          this.$base_url +
            '/api/contacts/update_other_field_to_masterdb_from_csv_table',
          data
        )
        .then(response => {
          if (response.data.status == 'success') {
            self.sendCompletedEmail()

            console.log('Updated other field data to master db')
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    sendCompletedEmail () {
      let self = this
      let data = {}
      data.user_id = self.user_id
      data.message = 'Import None Core Fields has been completed.'
      data.subject = 'Import None Core Fields'
      axios
        .post(self.$base_url + '/api/contacts/send_completed_email', data)
        .then(response => {
          if (response.data.status == 'success') {
            self.$vs.notify({
              color: 'success',
              title: 'Import None Core Fields',
              text: 'The email has been sent'
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    deduplicateOldNewCSV () {
      let data = {}
      data.campaignId = this.campaignId
      axios
        .post(
          this.$base_url + '/api/contacts/deduplicate_old_new_csv_contact_data',
          data
        )
        .then(response => {
          if (response.data.status == 'success') {
            this.$router.replace(
              '/contacts/deduplicateOldAndNewcontactCSVData/' + this.campaignId
            )
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    ucFirstAllWords (str) {
      var pieces = str.split(' ')
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase()
        pieces[i] = j + pieces[i].substr(1)
      }
      return pieces.join(' ')
    },
    formatUploadedHeader (s) {
      if (typeof s !== 'string') return ''
      if (s.startsWith('ml_')) return ''
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s
    },
    // unmatchedIndividualBuildData () {
    //   let self = this
    //   this.$vs.loading()
    //   let data = {}
    //   data.campaignId = this.campaignId
    //   data.user_id = this.user_id
    //   axios
    //     .post(
    //       this.$base_url +
    //         '/api/contacts/get_accounts_that_have_no_contacts',
    //       data
    //     )
    //     .then(response => {
    //       let response_data = JSON.parse(response.data)


    //       console.log("RESPSSS" , response_data.rows)

    //       if( response_data.rows.length == 0 ){
    //         self.$vs.notify({
    //           color: 'success',
    //           title: 'No Build Contacts',
    //           text: 'There are no build contacts available.'
    //         })

    //         self.$router.push(
    //           '/data_build/contacts_data_administration_campaigns'
    //         )

    //         return false
    //       }

    //       self.unmatch_contacts = response_data.rows.slice(
    //         (self.currentx - 1) * self.limit,
    //         self.currentx * self.limit
    //       )

    //       self.all_unmatched_contacts = response_data.rows

    //       self.all_unmatched_contacts = self.all_unmatched_contacts.map(el => {
    //         let resultobj = {}
    //         Object.entries(el).map(([key, val]) => {
    //           resultobj[
    //             key.split(' ').join('_').replace(/\W+/g, '').toLowerCase()
    //           ] = val
    //           return resultobj
    //         })
    //         return resultobj
    //       })

    //       self.writeMasterDatabaseAndMatch(self.all_unmatched_contacts[0])

    //       let total = response_data.total_pages
    //       self.all_total = total


    //       // this.table = response_data.campaign_table_data[0]['table_name'];
    //       self.$vs.loading.close()
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    
     unmatchedIndividualBuildDataById () {
      let self = this
      this.$vs.loading()
      let data = {}
      data.campaignId = this.campaignId
      data.user_id = this.user_id
      data.table_id = this.$route.params.tableId
      axios
        .post(
          this.$base_url +
            '/api/contacts/get_accounts_that_have_no_contacts_by_table_id',
          data
        )
        .then(response => {
          let response_data = JSON.parse(response.data)

          self.unmatch_contacts = response_data.rows.slice(
            (self.currentx - 1) * self.limit,
            self.currentx * self.limit
          )

          self.all_unmatched_contacts = response_data.rows

          self.all_unmatched_contacts = self.all_unmatched_contacts.map(el => {


            let resultobj = {}
            Object.entries(el).map(([key, val]) => {
              resultobj[
                key.split(' ').join('_').replace(/\W+/g, '').toLowerCase()
              ] = val
              return resultobj
            })
            return resultobj
          })


          self.writeMasterDatabaseAndMatch(self.all_unmatched_contacts[0])

          let total = response_data.total_pages
          self.all_total = total

          self.field_array_columns = response_data.campaign_table_data

          // this.table = response_data.campaign_table_data[0]['table_name'];
          self.$vs.loading.close()
        })
        .catch(error => {
          console.log(error)
        })
    },
    removeSelectedWeb (url) {
      this.contactDescription.web = this.contactDescription.web.filter(item => {
        return item != url
      })

      this.addEmail()
    },
    removeSelectedLinkedin (url) {
      this.contactDescription.contact_social_media =
        this.contactDescription.contact_social_media.filter(item => {
          return item != url
        })

      this.addLinkedin()
    },

    removesubsidiarySelectedWeb (url) {
      this.subsidiarycontactDescription.web =
        this.subsidiarycontactDescription.web.filter(item => {
          return item != url
        })
    },
    removesubsidiarySelectedLinkedin (url) {
      this.subsidiarycontactDescription.linkedin =
        this.subsidiarycontactDescription.linkedin.filter(item => {
          return item != url
        })
    },
    removeSelectedPhone (phone) {
      this.contactDescription.phone = this.contactDescription.phone.filter(
        item => {
          return item != phone
        }
      )

      this.addEmail()
    },

    removesubsidiarySelectedPhone (phone) {
      this.subsidiarycontactDescription.phone =
        this.subsidiarycontactDescription.phone.filter(item => {
          return item != phone
        })

      this.subsidiaryaddEmail()
    },
    removeSelectedSicCode (sic_code) {
      this.contactDescription.sic_code =
        this.contactDescription.sic_code.filter(item => {
          return item != sic_code
        })
    },
    removeNewSelectedSicCode (selected) {
      this.contacts.joinedSicAndDescription =
        this.contacts.joinedSicAndDescription.filter(item => {
          return item != selected
        })
    },

    removeNewSelectedPhone (selected) {
      this.contacts.joinedPhoneAndTypes =
        this.contacts.joinedPhoneAndTypes.filter(item => {
          return item != selected
        })
    },
    validDomain (userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        )
        if (res == null) {
          return false
        }
      }
      return true
    },

    addEmail () {
      if (
        this.contactDescription.email == undefined ||
        this.contactDescription.email == null
      ) {
        this.contactDescription.email = []
      }

      this.getMatchedEmails(this.contactDescription.email)
    },
    AddEmailAnyWay () {



      if (
        !this.contactDescription.emails.includes(this.contactDescription.email)
      ) {
        this.contactDescription.emails.push({
          email: this.contactDescription.email,
          primary: false
        })
      }

      this.contactDescription.email = null
      this.MatchedEmailPopupActive = false


    },
    CancelEmailPopup () {
      this.contactDescription.email = null
      this.MatchedEmailPopupActive = false
    },
      addSocialMedia () {
      if (
        this.contactDescription.social_media == undefined ||
        this.contactDescription.social_media == null
      ) {
        this.contactDescription.social_media = []
      }

      this.getMatchedSocialMedias(this.contactDescription.social_media , this.contactDescription.summary)
    },
     AddSocialMediaAnyWay () {


      if (this.contactDescription.summary == undefined) {
        this.contactDescription.summary = ''
      }


     console.log("ADDING ANY WAY" , this.contactDescription.social_media , this.contactDescription.summary)



      if (
        !this.contactDescription.social_medias.includes(this.contactDescription.social_media)
      ) {
        this.contactDescription.social_medias.push({
          social_media: this.contactDescription.social_media,
          summary: this.contactDescription.summary,
          primary: false
        })
      }

      this.contactDescription.social_media = null
      this.contactDescription.summary = null
      this.MatchedSocialMediaPopupActive = false
    },
    CancelSocialMediaPopup () {
      this.contactDescription.social_media = null
      this.MatchedSocialMediaPopupActive = false
    },
  
    AddMatchedNoneCoreFields () {
      this.$store
        .dispatch(
          'contactsManagement/AddMatchedNoneCoreFields',
          this.contactDescription
        )
        .then(res => {
          if (res.data.status == 'success') {
            console.log('Matched None Core Fields Added Successfully')
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    addcontacts () {


      let self = this

       if (Array.isArray(this.contactDescription.role)) {
        this.contactDescription.role = this.contactDescription.role[0]
      }

      if (Array.isArray(this.contactDescription.sub_role)) {
        this.contactDescription.sub_role = this.contactDescription.sub_role[0]
      }

      if (Array.isArray(this.contactDescription.seniority)) {
        this.contactDescription.seniority = this.contactDescription.seniority[0]
      }

      this.contactDescription.primary_social_media = false
      this.contactDescription.primary_email = false
      this.contactDescription.primary_mobile = false
      this.contactDescription.primary_ddi = false

      this.contactDescription.account_id = this.contactDescription.accepted
    this.contactDescription.user_id = this.user_id
    this.contactDescription.campaignId = this.$route.params.campaignId


      this.$store
        .dispatch(
          'contactsManagement/buildContactToAccountAndAddToCampaign',
          this.contactDescription
        )
        .then(res => {
          if (res.data.status == 'success') {
          this.$vs.notify({
              color: 'success',
              title: 'contact Added',
              text: 'The contact was added successfully'
            })

            this.$router.go(0)
        }
          })
        .catch(err => {
          console.log(err)
        })
    },
     addContactsAnyway () {


      let self = this

       if (Array.isArray(this.contactDescription.role)) {
        this.contactDescription.role = this.contactDescription.role[0]
      }

      if (Array.isArray(this.contactDescription.sub_role)) {
        this.contactDescription.sub_role = this.contactDescription.sub_role[0]
      }

      if (Array.isArray(this.contactDescription.seniority)) {
        this.contactDescription.seniority = this.contactDescription.seniority[0]
      }

      this.$store
        .dispatch(
          'contactsManagement/buildcontactAndAddToCampaignAnyway',
          this.contactDescription
        )
        .then(res => {
          if (res.data.status == 'required_correction') {
            this.$vs.dialog({
              color: 'primary',
              title: `Required Correction`,
              text: 'The fields with red title should be corrected. Please update it and submit again'
            })

            self.correction_fields_array = res.data.correction_fields
          } else if (
            res.data.status ==
            'company_name_and_forename_surname_job_title_exists'
          ) {
            self.submit_match_contacts = res.data.data
            self.MatchedContactsPopupActive = true

            console.log(
              'Company Name and Registered Office Country Exists',
              res.data.data
            )
          } else {
            this.$vs.notify({
              color: 'success',
              title: 'contact Added',
              text: 'The contact was added successfully'
            })

            this.$router.go(0)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
      showParentName(parentId) {
      this.$store
        .dispatch("accountsManagement/getParent", parentId)
        .then(res => {
          this.parent_name = res.data.company_name;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true;
            return;
          }
          console.error(err);
        });
    },
    showRegistrationJurisdiction(countryId) {
      this.$store
        .dispatch("accountsManagement/getCountry", countryId)
        .then(res => {
          this.RegistrationJurisdiction = res.data.name_1;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true;
            return;
          }
          console.error(err);
        });
    },

    showVertical(verticalId) {
      this.$store
        .dispatch("accountsManagement/getVertical", verticalId)
        .then(res => {
          this.verticalName = res.data.vertical;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    viewAccountDetails (accountId) {
      this.$store
        .dispatch('accountsManagement/fetchAccount', accountId)
        .then(res => {
          this.viewAccountDescription = res.data


      if (this.viewAccountDescription.parent) {
            this.showParentName(this.viewAccountDescription.parent);
          }
          if (this.viewAccountDescription.registration_jurisdiction) {
            this.showRegistrationJurisdiction(
              this.viewAccountDescription.registration_jurisdiction
            );
          }
          if (this.viewAccountDescription.vertical) {
            this.showVertical(this.viewAccountDescription.vertical);
          }



          this.showUpdateSAccountDetailsPopup = true
          this.updateAccountDetailsPopupActive = true




          
        })
        .catch(err => {
          console.error(err)
        })
    },
       addNonExistingAccountToCampaignAccountTable () {
      let self = this
      let data = {}


      data.account_id = this.contactDescription.accepted
      data.campaign_id = this.campaignId
      this.$store
        .dispatch('accountsManagement/addNonExistingAccountToCampaignAccountTable', data)
        .then(res => {
          console.log(
            'addNonExistingAccountToCampaignAccountTable')
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },

        getExistingCampaignContactMatches () {
      let self = this
      self.existing_campaign_contact_matches = []
      let data = {}
      data.campaign_id = this.campaignId
      data.account_id = this.contactDescription.accepted

      console.log('ACCC', this.contactDescription)

      this.$store
        .dispatch('contactsManagement/getExistingCampaignContactMatches', data)
        .then(res => {
          self.existing_campaign_contact_matches = res.data

          self.existing_campaign_contact_matches.forEach((contact) => {
            self.existed_contact_ids.push(contact.contact_id)
          })

        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getExistingMasterDatabaseContactsMatches () {
      let self = this
      self.existing_master_database_contacts = []
      let data = {}
      data.campaign_id = this.campaignId
      data.account_id = this.contactDescription.accepted

      console.log('ACCC', this.contactDescription)

      this.$store
        .dispatch('contactsManagement/getExistingMasterDatabaseContactsMatches', data)
        .then(res => {
          self.existing_master_database_contacts = res.data

        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getMatchedEmails (email) {
      let self = this

      if (email != null && email != '') {
        email = email.trim()
      }

      self.matched_emails = []
      let data = {}
      data.email = email

      this.$store
        .dispatch('contactsManagement/getMatchedEmails', data)
        .then(res => {
          if (res.data.length != 0) {
            self.matched_emails = res.data
            self.MatchedEmailPopupActive = true
          } else {
            self.AddEmailAnyWay(data.email)
          }

        })
        .catch(err => {
         console.log(err)
        })
    },
    getMatchedSocialMedias (social_media , summary) {
      let self = this

      if (social_media != null && social_media != '') {
        social_media = social_media.trim()
      }

      self.matched_social_medias = []
      let data = {}
      data.social_media = social_media

      this.$store
        .dispatch('contactsManagement/getMatchedSocialMedias', data)
        .then(res => {
          if (res.data.length != 0) {
            self.matched_social_medias = res.data
            self.MatchedSocialMediaPopupActive = true
          } else {
            self.AddSocialMediaAnyWay(data.social_media, summary)
          }

        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },

    getCorrectionFields () {
      let self = this
      self.correction_fields_array = []
      let data = {}
      data.seniority = this.contactDescription.seniority
      data.role = this.contactDescription.role
      data.sub_role = this.contactDescription.sub_role
      data.ddi_phone_code = this.contactDescription.ddi_phone_code
      data.ddi = this.contactDescription.ddi
      data.mobile_phone_code = this.contactDescription.mobile_phone_code
      data.mobile = this.contactDescription.mobile
      data.campaign_id = this.campaignId
      data.table_id = this.temp_table_id

      this.$store
        .dispatch('contactsManagement/getCorrectionFields', data)
        .then(res => {
          self.correction_fields_array = res.data

          console.log('CORRECTION FIELDS', self.correction_fields_array)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },

    accept () {
      this.popupActive = false
    },
    reject () {
      // this.popupActive = false;
      // this.$router.push({ path: "/dashboard" });
      this.$router.go(0)
    }
  },
  created () {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    })
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.user_id = userInfo['uid']

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        'campaignsManagement',
        moduleCampaignsManagement
      )
      moduleCampaignsManagement.isRegistered = true
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule('accountsManagement', moduleAccountsManagement)
      moduleAccountsManagement.isRegistered = true
    }

    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule('contactsManagement', moduleContactsManagement)
      moduleContactsManagement.isRegistered = true
    }

    this.campaignId = this.$route.params.campaignId
  }
}
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.searchbox2 {
  padding-left: 40px;
  width: 500px;
  float: right;
  margin-top: 10px;
  margin-bottom: 50px;
}

.satellite_office_field {
  margin-right: 453px;
}

.relative {
  /* position: fixed !important; */
  z-index: 999;
  /* width: 98.5%; */
}

.vxtable {
  /* position: absolute !important; */
  margin-top: 20px;
}

.correction_field_class {
  color: red;
}

.correction_field_input_class {
  border: 1px solid red;
}

.vs-input-class {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  height: 38px;
  padding-left: 10px;
  padding-right: -10px;
  border-radius: 4px;
  background: transparent;
  transition: all 0.2s ease;
}


.scroll-container {
  max-height: 400px; /* Set a maximum height to enable scrolling */
  overflow-y: auto; /* Adds a vertical scrollbar if content exceeds max-height */
  /* Hide horizontal scrollbar if necessary */
  overflow-x: hidden;
  border: 1px solid #ccc;
  padding: 10px;
}


.build-complete {
  background-color: rgb(107, 42, 42) !important;
  padding: 0.75rem 2rem;
  border: 1px solid rgb(94, 70, 70);
  color: #fff !important;
  border-radius: 4px;
  cursor: pointer;

    font-size: 18px;

}


</style>
